export const LogoMark = ({ size = 40 }) => (
  <img
    src="/logo-icon-trans.png"
    alt="Saga Logística"
    width={size}
    height={size}
    className="object-contain"
  />
);

export const Logo = ({ compact = false }) => (
  <img
    src="/logo-trans.png"
    alt="Saga Logística"
    style={{ height: compact ? 42 : 54 }}
    className="w-auto object-contain drop-shadow-[0_2px_10px_rgba(0,0,0,0.45)]"
  />
);
